export default __webpack_public_path__ + "static/char-v-39-zh-Hant-066f35a249b4104e1c2ed4ab6a572ff7.mp4";